import {hideExpiringBadgePopup} from '@/state/slices/modalSlice';
import {dispatch} from '@/state/store';
import {ExpiringBadgePopupTemplate} from '@/views/Loyalty/PopupTemplates';

import LoyaltyModalPopup from './LoyaltyModalPopup';

const ExpiringBadgePopup = ({journeyId, timeInSeconds}) => {
    const handleClose = () => {
        dispatch(hideExpiringBadgePopup());
    };

    return (
        <LoyaltyModalPopup>
            <ExpiringBadgePopupTemplate
                journeyId={journeyId}
                timeInSeconds={timeInSeconds}
                onClose={handleClose}
                onAction={handleClose}
            />
        </LoyaltyModalPopup>
    );
};

export default ExpiringBadgePopup;
